export default __webpack_public_path__ + "static/faq-035da6f92873a0135d59837d7be9bef6.png";